import React, { useEffect, useRef, useState } from "react";
import "./InvoicePrint.css";
import "firebase/compat/firestore";
import { formatTotal, getDiscount, getTotal } from "../Data/Functions";
import { firestore } from "../firebase.config";
import { useReactToPrint } from "react-to-print";
import {ReactComponent as EVERBARY_LOGO} from "../assets/icons/everbary-logo-black.svg";

export const MultiInvoicePrint = ({ invoice, downloadInvoice, setDownloadInvoice, setShowBtns = () => {}}) => {

  const [teamData, setTeamData] = useState(null);
  const [teamOwner, setTeamOwner] = useState(null);
  const [loading, setLoading] = useState(false);
 
   const [orders, setOrders] = useState([]);
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Invoice ${invoice.invoiceNumber}`,
    });

    useEffect(() => {
        if(invoice && downloadInvoice === invoice.id){
            handlePrint();
            setDownloadInvoice("");
        }
    }, 
    [downloadInvoice, invoice]);


  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return (
      splitted[1] +
      " " +
      splitted[2] +
      ", " +
      splitted[3] +
      " @ " +
      date.toTimeString().substr(0, 5)
    );
  };

    useEffect(() => { 
      if(invoice){
        firestore.collection("orders").where("orderInvoiceId", "==", invoice.id)
        .where("status", "!=", "cancelled")
        .get().then((qSnap) => {
  
          if(qSnap.empty){
            return;
          }
  
          const ordersData = qSnap.docs.map(doc => ({...doc.data(), id: doc.id}));
          setOrders(ordersData);
        }).catch((error) => {
          console.log(error);
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoice]);
    

    useEffect(() => {
        try{
          setLoading(true);
          if (invoice && invoice.teamId) {
            getTeamData(invoice.teamId);
            getTeamOwner(invoice.teamId);
          } else {
            setTeamOwner(null);
          }
        }catch(error){
          console.log(error)
        }finally{
          setLoading(false);
        }
    
      }, [invoice])
    
      const getTeamData = async (teamId) => {
        try{
          if (!teamId) return;
          firestore.collection("teams").doc(teamId).get().then((doc) => {
            if(doc.exists){
              setTeamData({ id: doc.id, ...doc.data() });
            }
          });
         
      }catch(error){
          console.log(error)
        }
      }
    
      const getTeamOwner = async (teamId) => {
        try{
          if (!teamId ) return;
          firestore.collection("users").where("teamId", "==", teamId).where("teamRole", "==", "owner").get().then((qSnap) => {
            if(!qSnap.empty){
              const user = qSnap.docs[0].data();
              setTeamOwner({ id: qSnap.docs[0].id, ...user });
            }
          });
        }catch(error){
          console.log(error)
        }
      }

  if (!invoice || loading || !teamData || !teamOwner) {
    return <div>Loading,Please wait<span className="loadingDots">...</span></div>;
  }else{
    setShowBtns(true);
  }
  return (
    <>
      <div
        ref={componentRef}
        className={`bg-[#f6f6f6] font-sans antialiased text-sm leading-relaxed h-dvh  mx-auto py-8 px-12 flex flex-col justify-between h-full`}
      >
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          className="border-separate w-full "
        >
          <tr>
            <td className="font-sans text-sm align-top block mx-auto mb-4  p-2.5">
              <div className="box-border block mx-auto p-2.5">
                <EVERBARY_LOGO/>
              </div>
            </td>
          </tr>
          <tr>
            <table className="w-full border-collapse">
              <tr>
                <td className="w-1/2 align-top p-4">
                  <h2 className={`text-[14px] font-bold}`}>
                    Invoice to:
                  </h2>
                  <p className="text-[14px] font-normal text-[#2d2d2d] my-2 tracking-tight leading-[13px]">
                    { teamData.name}
                  </p>
                  <p className="text-[12px] font-normal text-[#969696] tracking-tight leading-[13px]">
                    {teamOwner.name}
                  </p>
                </td>
                <td className="w-1/2 align-top p-4 text-left">
                  <h2 className={`text-[14px] font-bold mb-0`}>
                    Invoice #{invoice.invoiceNumber}
                  </h2>
                  <p className="flex justify-between border-b border-[#e0e0e0] mt-2 pb-2">
                    <strong className="text-[12px] text-[#2d2d2d]">Billing Period:</strong>
                    <span className="text-[12px] text-[#2d2d2d]">
                    {(invoice.billingPeriod)}
                    </span>
                  </p>
                  <p className="flex justify-between border-b border-[#e0e0e0] mt-2 pb-2">
                    <strong className="text-[12px] text-[#2d2d2d]">Orders:</strong>
                    <span className="text-[12px] text-[#2d2d2d]">
                      #{invoice.orders.length}
                    </span>
                  </p>
                  <p className="flex justify-between mt-0 py-2">
                    <strong className="text-[12px] text-[#2d2d2d]">Date:</strong>
                    <span className="text-[12px] text-[#2d2d2d]">
                      {formatDate(invoice.timestamp)}
                    </span>
                  </p>
                </td>
              </tr>
            </table>
          </tr>

          <tr>
            <div className="p-4 bg-[#fafafa] shadow-lg rounded-2xl my-12 w-full">
              <table className="w-full border-collapse rounded-2xl">
                <thead className="p-4">
                  <tr>
                    <th className={`invoiceHeader`}>Orders</th>
                    <th className={`invoiceHeader`}>Date</th>
                    <th className={`invoiceHeader`}></th>
                    <th className={`invoiceHeader`}>Client</th>
                    <th className={`invoiceHeader`}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                      <tr key={order.orderNUmber}>
                      <td className="invoiceItem">#{order.orderNumber}</td>
                      <td className="invoiceItem">{formatDate(order.timestamp)}</td>
                      <td className="invoiceItem"></td>
                      <td className="invoiceItem">{order.name}</td>
                      <td className="invoiceItem">{formatTotal(getTotal(order) - getDiscount(order))} </td>
                    </tr>
                  ))}
                  
                  <tr>
                    <td></td>
                    <td></td>
                    <td className={`invoiceHeader !border-none py-2`}>Total</td>
                    <td></td>
                    <td className={`invoiceHeader !border-none py-2 `}>{formatTotal(invoice.totalPrice)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </tr>
        </table>


        <table>
          <tr>
            <td className="mx-auto mb-8">
              <h1 className="text-center text-2xl font-semibold text-[#1eb8bc]">
                Thank you for choosing <span className="font-black">eVerbary!</span>
              </h1>
            </td>
          </tr>

          <tr>
            <td className="h-8"></td>
          </tr>
          <tr>
            <table className="w-full">
              <tr className="w-full flex justify-between">
                <td className="p-4">
                  <div className="flex items-center gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Fcall.svg?alt=media&token=715ea837-eec5-4faf-a7f8-1642c2fab565"
                      alt="call"
                      className="w-[18px] h-[18px]"
                    />
                    <span className="text-[14px] font-normal text-[#2d2d2d]">
                      +1 (505) 916-8399
                    </span>
                  </div>
                </td>
                <td className="p-4">
                  <div className="flex items-center gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2FblueEnvelop.svg?alt=media&token=adbff61f-4224-4292-808f-50acafd135da"
                      alt="email"
                      className="w-[18px] h-[18px]"
                    />
                    <span className="text-[14px] font-normal text-[#2d2d2d]">
                      support@everbary.com
                    </span>
                  </div>
                </td>
                <td className="p-4">
                  <div className="flex items-start gap-2">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Flocation.svg?alt=media&token=e991ba05-61a5-4e4e-94ec-09fd591bdb88"
                      alt="location"
                      className="w-[18px] h-[18px] mt-1"
                    />
                    <span className="text-[14px] font-normal text-[#2d2d2d] leading-[1.4]">
                      1209 Mountain Road Pl NE Ste N <br />
                      Albuquerque, NM 87110 <br />
                      United States
                    </span>
                  </div>
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
  
  </>
  )

};
